module.exports = __webpack_public_path__ + "static/img/manual-51.80c8de1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/vi/mobile/manual-51.png
// module id = isOo
// module chunks = 4